export const e2eLocators = {
  companiesControl: 'add-destination-companies-control',
  addNewCompanyBtn: 'add-destination-add-new-company-btn',
  bucketNameControl: 'bucket-name-control',
  displayBucketNameControl: 'display-bucket-name-control'
};
